import * as React from "react";
import { SpsDateRangePicker } from "./SpsDateRangePicker";
import { SpsCard } from "../card/SpsCard";
import * as momentImport from "moment-timezone";
const moment = momentImport as any;
export class SpsDateRangePickerExample extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static reactLive = {
        code: `
        <SpsCard>
            <SpsDateRangePicker/>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <SpsCard>
                <SpsDateRangePicker data-testid={testId} />
            </SpsCard>

        );
    }
}

export class SpsDateRangeMinMaxExample extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static reactLive = {
        code: `
        <SpsCard>
            <SpsDateRangePicker minDate="06/25/2019" maxDate="07/25/2019"/>
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        return (
            <SpsCard>
                <SpsDateRangePicker minDate="01/25/2019" maxDate="07/25/2019" data-testid={testId} />
            </SpsCard>
        );
    }
}

export class SpsDateRangeDisabledExample extends React.Component<{ "data-testid": any }> {
    // Used in react-live examples
    static reactLive = {
        code: `
        <SpsCard>
            <SpsDateRangePicker disabled />
        </SpsCard>
        `
    };
    render() {
        const { "data-testid": testId } = this.props;
        // Used in react-testing-library specs
        return (
            <SpsCard>
                <SpsDateRangePicker disabled data-testid={testId} />
            </SpsCard>
        );
    }
}

function SpsDateRangeCustomPresetExample(props) {
    const { "data-testid": testId } = this.props;
    const presets = [
        { days: 1 },
        { days: 15 },
        { months: 10 }
    ].map(moment.duration);

    return (
        <SpsDateRangePicker availablePresets={presets} data-testid={testId} />
    );
}

// @ts-ignore
SpsDateRangeCustomPresetExample.reactLive = {
    code: `
        function Component() {
            const presets = [
                { days: 1 },
                { days: 15 },
                { months: 10 }
            ].map(moment.duration);

            const onChangeHandler = (val) => {
                console.log(val);
            }

            return (<SpsDateRangePicker availablePresets={presets} onChange={onChangeHandler} />);
        }
        render(<Component />)
    `
};

function SpsDateRangeDefaultPresetExample(props) {
    const { "data-testid": testId } = this.props;
    const presets = [
        { days: 1 },
        { days: 15 },
        { months: 10 }
    ].map(moment.duration);

    return (
        <SpsDateRangePicker preset={{ days: 15 }} availablePresets={presets} data-testid={testId} />
    );
}

// @ts-ignore
SpsDateRangeDefaultPresetExample.reactLive = {
    code: `
        function Component() {
            const presets = [
                { days: 1 },
                { days: 15 },
                { months: 10 }
            ].map(moment.duration);

            return (<SpsDateRangePicker preset={{ days: 15 }} availablePresets={presets} />);
        }
        render(<Component />)
    `
};

export { SpsDateRangeCustomPresetExample, SpsDateRangeDefaultPresetExample }
